export const categories = [
  {
    id: "dianying",
    name: "电影",
    icon: "ri-movie-2-line",
    count: 8,
    description: "最新最热的电影大片，涵盖科幻、动作、悬疑、爱情等全类型"
  },
  {
    id: "dianshiju",
    name: "电视剧",
    icon: "ri-tv-2-line",
    count: 4,
    description: "追剧达人的天堂，热门国产剧、韩剧、美剧应有尽有"
  },
  {
    id: "zongyi",
    name: "综艺",
    icon: "ri-live-line",
    count: 3,
    description: "热门综艺一网打尽，真人秀、音乐竞演、搞笑娱乐"
  },
  {
    id: "dongman",
    name: "动漫",
    icon: "ri-emotion-happy-line",
    count: 4,
    description: "国漫崛起，日漫经典，总有一部让你爱上二次元"
  }
];